import Header from "../Header";

export default function NoBookFound() {
    return (
        <div>
            <Header/>
            <p>No book found</p>
        </div>

    );
}